const PersonalBudget = () => import(/* webpackChunkName: "personalBudget" */ './PersonalBudget.vue')
const ConfigBudget = () => import(/* webpackChunkName: "configBudget" */ './ConfigBudget.vue')

const index = {
  path: 'personal/budget',
  name: 'Personal Budget',
  component: PersonalBudget,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const config = {
  path: 'personal/budget/config',
  name: 'Config Personal Budget',
  component: ConfigBudget,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index,
  config
}
